export function Eyebrow({
  children,
  className,
  size = 'note'
}: {
  children: React.ReactNode;
  className?: string;
  /** Type size: "note" = 14px (default), "body" = 16px. */
  size?: 'note' | 'body';
}) {
  const sizeClass = size === 'body' ? 'text-body' : 'text-note';
  return (
    <div
      className={`${sizeClass} font-medium tracking-normal text-zeb-primary${
        className ? ` ${className}` : ''
      }`}>
      {children}
    </div>
  );
}
